<!--
* UIID: UI-XMB-120
* UI Name: Xml Mapper List
* Modify Date: 2022/05/19
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.dbMapperTest.xmlMapperList.title')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
      <!-- [S]  Data Section-->
      <v-row class="ma-0 map-pb-search">
        <v-col cols="8" class="pa-0"></v-col>
        <v-col cols="1" class="map-popup-locked">
          <v-label>{{ $t('lbl.common.lockerTitle') }}</v-label>
          <div class="map-dv-select-locked">
            <v-select
              v-model="filterItems.locked"
              :items="lockedItems"
              @change="filterMapList"
              height="30"
              solo
              dense
              hide-details
            ></v-select>
          </div>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0 pr-0 pl-5 map-search">
          <v-text-field
            v-model="filterItems.search"
            @input="filterMapList"
            @click:append="filterMapList"
            @keyup.enter="filterMapList"
            class="search-matched-map-list-button custom-form-component search-button"
            placeholder="Search"
            outlined
            dense
            solo
            hide-details
            append-icon="fas fa-search"
            height="30"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="mapList"
            :items-per-page="-1"
            :hide-default-footer="true"
            :disable-sort="true"
            class="map-list-table pb-0"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.mapper_id">
                  <td class="map-name-col">{{ item.mapper_name }}</td>
                  <td class="map-name-col">{{ item.dba_name }}</td>
                  <td class="locked-col">
                    <v-icon
                      v-if="item.lock_yn === 'Y'"
                      small
                      @click.native="releaseLockedMap(item, 'MAPP')"
                      >fas fa-check-square</v-icon
                    >
                    <v-icon v-if="item.lock_yn === 'N'" small>far fa-window-close</v-icon>
                  </td>
                  <!-- <td class="map-name-col">{{ item.sql_grp_nm }}</td> -->
                  <td class="version-col">
                    <a class="link-file-text" @click="openDBMapperVersion(item)">{{
                      item.mapper_ver
                    }}</a>
                  </td>
                  <td class="date-col no-wrap">
                    <span>{{ item.upd_dt }}</span>
                  </td>
                  <td class="customer-col">{{ item.upd_usr_id }}</td>
                  <td class="locked-col">
                    <v-btn
                      small
                      text
                      icon
                      @click="deleteMapper(item)"
                      :disabled="item.numofuse > 0"
                    >
                      <icon-svg :disabled="item.numofuse > 0" iconName="delete" />
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- [E]  Data Section-->
    </v-card-text>
    <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog">{{ $t('btn.common.close') }}</v-btn>
        </div>
      </v-col>
    </v-row>
    <dialogWindow
      ref="warningCheckedOutMapperDialog"
      size="max"
      :detail="
        $t('msg.common.warning.detailWarningReleaseLocked', ['mapper', updateUserId, 'Mapper'])
      "
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.dbMapperManager.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDelete($event)"
      :showCancel="true"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import cfg from '@/vue-caas/config/config.js';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

/* 2020/11/11 203737 Remove unused source
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert
} from "@/vue-dlb/utils/sys-util.js";*/

export default {
  components: {
    DialogDrag,
    SystemProgress,
    dialogWindow,
    IconSvg,
  },
  name: 'maplist-dialog',
  /* 2020/10/29 203737 Change prop definitions
  props: ['id', 'title', 'options', 'eventCb','selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','fileSelected'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  watch: {
    listData() {
      return this.mapList;
    },
  },
  computed: {
    // ...mapState("mapbuilder", {
    //   mapList: "mapList",
    //   appliedList: "appliedList",
    // }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  data() {
    return {
      mapData: [],
      customerSelect: false,
      mapList: [],
      masterSearchItems: {
        header: ['ADMIN_YN', 'CUST_ID', 'LOCK_YN', 'MAP_PRCS_NO'],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            LOCK_YN: '',
            MAP_PRCS_NO: '',
          },
        ],
      },
      filterItems: {
        cus: '',
        locked: '',
        search: '',
        CheckScanner: false,
      },
      SummDataList: {
        headers: [
          { text: 'DB Mapper Name', value: 'mapper_name' },
          { text: 'DB Adapter Name', value: 'dba_name' },
          { text: 'Locked', value: 'lock_yn' },
          // { text: "DB Mapper", value: "sql_grp_nm" },
          { text: 'Version', value: 'mapper_ver' },
          // { text: "Customer", value: "MST_CUST_ID" },
          { text: 'Update Date', value: 'upd_dt' },
          { text: 'Update User', value: 'upd_usr_id' },
          { text: 'Delete' },
        ],
      },
      lockedItems: [
        { text: 'All', value: '' },
        { text: 'Y', value: 'Y' },
        { text: 'N', value: 'N' },
      ],
      customerItems: [
        { text: 'All', value: '' },
        { text: 'Customer', value: 'ENDUSER' },
        { text: 'Admin', value: 'ADMIN' },
      ],
      releaseLockItems: {
        header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            MAP_KIND: '',
            MAP_PRCS_NO: '',
            LOCK_YN: 'N',
          },
        ],
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      isLoading: true,
      currentUserId: '',
      updateUserId: '',
      deleteItem: {},
      deleteData: '',
      deleteDataName: '',
    };
  },
  created() {
    this.queryMapList();
    if ($cookies.get('comp-id') == cfg.provider) {
      this.customerSelect = true;
    }
    EventBus.$on('refresh-map-list', this.queryMapList);
  },
  methods: {
    deleteMapper(item) {
      this.deleteData = item.mapper_id;
      this.deleteDataName = item.mapper_name;
      this.deleteItem = item;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    okDelete(item) {
      this.$store.dispatch('deleteDBAdapterMapper', this.deleteItem).then((res) => {
        this.queryMapList();
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    releaseLockedMap(item, type) {
      Store.dispatch('dbAapterMapperUpdateLock', { mapper_id: item.mapper_id }).then(() => {
        this.queryMapList();
      });
    },
    queryMapList() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log('--------- getSummaryList ----------');
      Store.dispatch('getDBMapperAdapterList', { agent_id: this.options.item.item.agent_id })
        .then(() => {
          console.log('--------- Finished to process ----------');
          this.mapList = this.$store.getters.dbMapperAdapterList;
          this.mapData = this.mapList;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterMapList() {
      Store.commit('SET_DB_ADAPTER_MAPPER_FILTER', this.filterItems);
      this.mapList = this.$store.getters.dbMapperAdapterList;
      this.mapData = this.mapList;
    },
    openDBMapperVersion(itemRow) {
      this.$emit('openDBMapperVersion', itemRow);
    },
    openMapperVersion(itemRow) {
      let isCheckedOut = this.getIsCheckedOut(itemRow, 'MAPP');
      itemRow.isCheckedOut = isCheckedOut;
      this.$emit('openMapperVersion', itemRow);
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialogVersion(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    getIsCheckedOut(itemRow, type) {
      let isCheckedOut = false;
      this.currentUserId = $cookies.get('user-id');
      this.updateUserId = itemRow.MAP_UPD_USR;
      let isLocked;

      if (type === 'MAPP') {
        isLocked = itemRow.lock_yn === 'Y' ? true : false;
      } else {
        isLocked = itemRow.lock_yn === 'Y' ? true : false;
      }

      if (this.currentUserId !== this.updateUserId && isLocked) {
        isCheckedOut = true;
      }
      return isCheckedOut;
    },
  },
};
</script>
